// Uso de un producto con inventario (giro restaurante): una sola definición para la ficha
// de productos (productCRUD.vue) y para el alta desde una línea de compra (purchaseForm.vue).
//
// El producto guarda dos campos, `isSellable` y `stockMode`, pero solo tres combinaciones
// son válidas: el backend corrige la cuarta (periódico y a la venta) en
// Product._normalizeUsage. Un único selector de tres opciones no puede expresarla.
export const PRODUCT_KINDS = [
    { label: 'Se vende', value: 'SELL',
      hint: 'Sale en la venta y también puede ir en recetas.' },
    { label: 'Insumo de receta', value: 'RECIPE',
      hint: 'No se vende: lo bajan las recetas (pan, carne) y el conteo muestra las diferencias.' },
    { label: 'Insumo de consumo', value: 'CONSUMPTION',
      hint: 'No se vende ni va en recetas: solo lo bajan los conteos (sal, aceite, limpieza).' },
];

export function usageFor(kind) {
    if (kind === 'RECIPE') return { isSellable: false, stockMode: 'PERPETUAL' };
    if (kind === 'CONSUMPTION') return { isSellable: false, stockMode: 'PERIODIC' };
    return { isSellable: true, stockMode: 'PERPETUAL' };
}

export function kindFor(product) {
    if (product.stockMode === 'PERIODIC') return 'CONSUMPTION';
    return product.isSellable === false ? 'RECIPE' : 'SELL';
}

export function kindHint(kind) {
    const option = PRODUCT_KINDS.find(k => k.value === kind);
    return option ? option.hint : '';
}
